import {DeepPartial} from 'react-hook-form';

import {defaultTo, isNotNil} from 'ramda';

import {GetDirectSaleLabourItemCalculatePriceRequest} from '@dms/api/warehouse';

import {EditLabourItemForm} from '../../../../../types/EditLabourItemForm';

const PERCENTAGE_BASE = 100;

type CalculatePriceBody = GetDirectSaleLabourItemCalculatePriceRequest['body'];

interface BuildCalculatePriceBodyOptions {
  getCurrentPrice: boolean;
  workType?: string;
}

/**
 * Builds the calculate-price request body from labour item form values.
 * Shared by the live (read-only) price preview query and the imperative
 * recalculation triggered on work type change / "get current price".
 */
export function buildCalculatePriceBody(
  formValues: DeepPartial<EditLabourItemForm>,
  options: BuildCalculatePriceBodyOptions
): CalculatePriceBody {
  return {
    quantity: formValues.quantity,
    workType: options.workType ?? formValues.workType,
    sellingPricePerUnit: formValues.sellingPricePerUnit,
    isCustomPrice: formValues.isCustomPrice,
    vatType: formValues.vatType,
    assignMechanics: formValues.assignMechanics
      ?.filter((mechanic) => isNotNil(mechanic?.id))
      .map((mechanic, index) => ({
        id: mechanic?.id,
        isDefault: index === 0,
        amount: mechanic?.amount,
      })),
    discount: {
      isDoNotApplyDiscount: formValues.discount?.isDoNotApplyDiscount,
      isDiscountEnable: formValues.discount?.isDiscountEnable,
      discountSourceType: formValues.discount?.discountSourceType,
      discountRate: formValues.discount?.isDiscountEnable
        ? defaultTo(0, formValues.discount.discountRate) / PERCENTAGE_BASE
        : 0,
    },
    getCurrentPrice: options.getCurrentPrice,
  };
}
